
import {THREE,createStudio,loadSpa,setEvening,tickSpa,MODEL_FILE,assetURL} from './pbspa-spa-stage.js';

const hero=document.querySelector('.lx-hero');
if(hero)start();

function start(){
const models=window.PB_HT?.models||[];if(!models.length)return;
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const saveData=navigator.connection?.saveData===true;
const mobile=matchMedia('(max-width:800px)').matches;
const q=s=>hero.querySelector(s),all=s=>[...hero.querySelectorAll(s)];



const FEATURES={
 lounge:{label:'Lounge',anchor:'lounge',cam:{side:'across',pitch:.62,dist:.95,aim:.85},
  title:()=>'The full-length lounge',
  copy:m=>`Lie back rather than sit up: the lounger is moulded for the whole body, with jets at the shoulders, down the back and at the calves. ${m.defining}`},
 therapy:{label:'Therapy seat',anchor:'therapy',cam:{side:'across',pitch:.5,dist:.82,aim:.95},
  title:()=>'A seat built around one big jet',
  copy:()=>'The 133 mm Power jet sits at the spine, twin-roto Minis at the shoulders and Poly multi-massage jets low in the back. Turn any jet face to set its own volume.'},
 seats:{label:'Seating',anchor:'seats',cam:{side:'across',pitch:.58,dist:.9,aim:.8},
  title:m=>`${m.seatsLabel}, each its own shape`,
  copy:m=>m.lounger?'Bucket seats wrap round the lounger, each with its own jet pattern; the corner seats carry a head cushion.'
                   :'Seven places around an octagonal footwell: corner seats with head cushions, side seats with their own smaller jet patterns.'},
 jets:{label:'Hydrotherapy',anchor:'jets',cam:{side:'across',pitch:.45,dist:.66,aim:.95},
  title:m=>`${m.jets} jets, four sizes`,
  copy:m=>`Omni Swirl jets from the 59 mm Cluster to the 133 mm Power, with fixed micro jets at the neck. ${m.pumps}.`},
 footwell:{label:'Footwell',anchor:'footwell',cam:{side:'near',pitch:1.02,dist:.78,aim:.9},
  title:()=>'The footwell',
  copy:m=>m.lounger?'The floor drops away between the seats, so everyone can stretch out; the suction covers sit low in its walls.'
                   :'An octagonal well with a Power jet in each corner face for the feet, and the VGB-compliant suctions set in its sides.'},
 headrests:{label:'Head cushions',anchor:'headrests',cam:{side:'across',pitch:.4,dist:.6,aim:.95},
  title:()=>'Head cushions in the corners',
  copy:()=>'Cushions swept along the corner of the rim, flush with it, so your neck is supported at the waterline and the cover still closes flat. Micro jets sit just below.'},
 controls:{label:'Controls',anchor:'controls',cam:{side:'across',pitch:.78,dist:.36,aim:1},   // from where the bather reads it
  title:()=>'Balboa TP500S keypad',
  copy:()=>'Warm and cool on the left, menu, jets, light and aux on the right, the temperature in the middle — on an oval panel set into a moulded pad in the rim.'},
 filter:{label:'Filtration',anchor:'filter',cam:{side:'across',pitch:.46,dist:.56,aim:1},   // facing the intake: slot, weir, lid
  title:()=>'DynaFlo skim filter',
  copy:()=>'Surface water spills over a floating weir into the basket and down one 75 sq ft cartridge. Turn the trim ring to lift it all out — no tools.'},
 lighting:{label:'LED lighting',anchor:'lighting',cam:{side:'across',pitch:.5,dist:.95,aim:.7},evening:true,
  title:()=>'Lit from inside the water',
  copy:()=>'Perimeter LED lenses on the wall and deck, and the spa light in the step riser, so the contours are lit for getting in and out after dark.'},
 waterfeature:{label:'Water feature',anchor:'waterfeature',cam:{side:'across',pitch:.38,dist:.95,aim:.6},evening:true,
  title:()=>'LED pop-up water feature',
  copy:()=>'Rises from the deck when it runs and throws a lit rope of water into the spa; turn the trim ring to aim it.'},
 cabinet:{label:'Cabinet',anchor:'cabinet',cam:{side:'near',pitch:.2,dist:1.25,aim:.5,drop:true,turn:.62},
  title:()=>'Polysteel cabinet',
  copy:()=>'Board panels with a groove between each, vertical corner boards and a recessed base, under the acrylic lip rolled over the top.'},
 cupholders:{label:'Cup holders',anchor:'cupholders',cam:{side:'near',pitch:.8,dist:.34,aim:1},
  title:()=>'Cup holders in the rim',
  copy:()=>'Moulded into the corners of the deck, within reach of the seats and clear of the cover line.'}
};

const PLAN630=['lounge','therapy','jets','filter','controls','cabinet'];
const PLAN={
 '630L-115':PLAN630,'630L-230':PLAN630,
 '743L-230':['lounge','therapy','footwell','headrests','controls','filter','lighting'],
 '744B-230':['seats','therapy','footwell','headrests','controls','filter','waterfeature']
};
const featuresFor=m=>(PLAN[m.code]||PLAN['743L-230']).map(k=>({key:k,...FEATURES[k]}));


const canvas=q('.lx-hero__canvas'),spots=q('.lx-hero__spots'),poster=q('.lx-hero__poster');
const card=q('.lx-hero__feature'),fallback=q('.lx-hero__fallback');

if(mobile)q('.lx-hero__copy').append(card);
const studio=(reduce||saveData)?null:createStudio(canvas);
let lastScroll=0;
let spa=null,ring=null,current=models.find(m=>m.code==='743L-230')||models[0],features=[],focus=-1,ready=false,reveal=false;
let yaw=-.5,yawTo=-.5,pitch=.46,pitchTo=.46,dist=6,distTo=6,drag=false,lastX=0,flight=false;
const target=new THREE.Vector3(0,.3,0),targetTo=new THREE.Vector3(0,.3,0);
const lerp=(a,b,t)=>a+(b-a)*t;
// Frame-rate independent easing: the same move takes the same time on a slow device.
let lastT=0,quiet=0;const ease=(rate,dt)=>1-Math.pow(1-rate,dt*60);
const topAsset=m=>window.PB_HT?.__imgs?.['lx-top-'+m.code+'.webp']||('assets/lx-top-'+m.code+'.webp');

const ASSETS=window.PB_ASSET_BASE||'assets/';

const built=new Map();            // keyed by shell, not by variant:
                                  // the 630L 115 V and 230 V are one moulding
let loadToken=0,askedAt=0;
async function buildFor(model){
 if(!studio)return;
 const token=++loadToken;
 const key=MODEL_FILE[model.code];
 let next=built.get(key)||await building.get(key);
 if(!next){
  
  const mark=n=>{try{performance.mark(n);}catch(e){}};
  mark('pb-load-start');
  try{
   next=await loadSpa({code:model.code,W:model.dims.w*.0254,D:model.dims.l*.0254,H:model.dims.h*.0254,
    renderer:studio.renderer,base:ASSETS,withWater:false});
  }catch(e){hero.classList.add('is-static');return;}
  mark('pb-load-built');
  next.visible=false;studio.scene.add(next);
  
  studio.renderer.compile(studio.scene,studio.camera);
  mark('pb-load-compiled');
  built.set(key,next);
 }
 if(token!==loadToken)return;                       // a newer choice won the race
 if(spa&&spa!==next)spa.visible=false;
 spa=next;spa.visible=true;
 
 hero.dataset.switchMs=String(Math.round(performance.now()-askedAt));
 setEvening(spa,state.evening);
 if(!ring||ring.parent!==spa){
  ring=new THREE.Mesh(new THREE.RingGeometry(.12,.17,48),
   new THREE.MeshBasicMaterial({color:0x8fd3cf,transparent:true,opacity:0,depthWrite:false}));
  ring.rotation.x=-Math.PI/2;spa.add(ring);
 }
 const base=5.35*(spa.userData.W/2.24);dist=distTo=mobile?base*1.12:base;
 targetTo.set(0,spa.userData.H*.52,0);target.copy(targetTo);
 renderSpots();overview();
 
 ready=true;
 hero.classList.remove('is-loading');
 reveal=true;                                       // the poster goes after the next drawn frame
 request();
}

let warmed=false;
const building=new Map();

function buildQuietly(model){
 const key=MODEL_FILE[model.code];
 const done=built.get(key);
 if(done)return Promise.resolve(done);
 if(building.has(key))return building.get(key);
 const p=loadSpa({code:model.code,W:model.dims.w*.0254,D:model.dims.l*.0254,H:model.dims.h*.0254,
  renderer:studio.renderer,base:ASSETS,withWater:false})
  .then(g=>{g.visible=false;studio.scene.add(g);studio.renderer.compile(studio.scene,studio.camera);
   built.set(key,g);return g;})
  .catch(()=>null);
 building.set(key,p);
 return p;
}

function warmWhenWanted(){
 if(warmed||!studio)return;
 let go=()=>{off();warmTheRest();};
 const bar=q('.lx-hero__models');
 const off=()=>{clearTimeout(timer);bar&&bar.removeEventListener('pointerenter',go);bar&&bar.removeEventListener('focusin',go);};
 
 const first=performance.getEntriesByName?.('pb-first-frame')[0];
 const timer=setTimeout(go,first&&first.startTime>3000?12000:4000);
 bar&&bar.addEventListener('pointerenter',go,{once:true});
 bar&&bar.addEventListener('focusin',go,{once:true});
}
function warmTheRest(){
 if(warmed||!studio)return;warmed=true;
 
 const rest=models.map(m=>m.code).filter((c,i,a)=>a.indexOf(c)===i&&MODEL_FILE[c]!==MODEL_FILE[current.code])
  .map(c=>models.find(m=>m.code===c));
 
 
 const next=()=>{
  if(performance.now()-lastScroll<1600)return void setTimeout(()=>idle(next),600);
  const m=rest.shift();if(!m){filmIfAble();return;}
  buildQuietly(m).then(()=>idle(next));
 };
 const idle=fn=>'requestIdleCallback' in window?requestIdleCallback(fn,{timeout:15000}):setTimeout(fn,2500);
 const soon=()=>idle(next);
 document.readyState==='complete'?soon():addEventListener('load',soon,{once:true});
}


function renderSpots(){
 spots.replaceChildren(...features.map((f,i)=>{
  const b=document.createElement('button');b.type='button';b.className='lx-spot';b.dataset.spot=i;
  b.innerHTML='<span class="lx-spot__dot"></span><span class="lx-spot__label">'+f.label+'</span>';
  b.setAttribute('aria-label',f.label+': '+f.title(current));
  b.addEventListener('click',()=>focusOn(i));
  return b;}));
 placeSpots();
}
function placeSpots(){
 const r=canvas.getBoundingClientRect();
 features.forEach((f,i)=>{
  const el=spots.children[i];if(!el)return;
  el.classList.toggle('is-active',i===focus);
  if(!spa||!studio){el.style.left=(20+i*15)+'%';el.style.top=(28+(i%2)*34)+'%';return;}
  const p=spa.userData.anchor(f.anchor);spa.localToWorld(p);
  const v=p.project(studio.camera);
  el.style.left=((v.x*.5+.5)*r.width).toFixed(1)+'px';
  el.style.top=((-v.y*.5+.5)*r.height).toFixed(1)+'px';
  el.style.opacity=v.z>1?'0':'';
 });
}
function focusOn(i){
 const f=features[i];if(!f)return;
 focus=i;hero.dataset.state='feature';hero.dataset.settled='false';
 q('.lx-hero__feature-label').textContent=f.label;
 q('.lx-hero__feature-title').textContent=f.title(current);
 q('.lx-hero__feature-copy').textContent=f.copy(current);
 card.hidden=false;
 if(!studio||!spa){placeSpots();return;}
 const p=spa.userData.anchor(f.anchor);spa.localToWorld(p);
 const c=f.cam||{side:'across',pitch:.55,dist:.8,aim:.85};
 
 const mid=new THREE.Vector3(0,spa.userData.rimY*.92,0);
 targetTo.copy(mid).lerp(p,c.aim);
 if(c.drop)targetTo.y=spa.userData.rimY*.45;
 let y=Math.atan2(p.x,p.z)+(c.side==='across'?Math.PI:0)+(c.turn||0);
 y+=Math.round((yaw-y)/(Math.PI*2))*Math.PI*2;           // the short way round
 yawTo=y;pitchTo=c.pitch;distTo=spa.userData.W*c.dist*(mobile?1.35:1);
 
 if(!mobile){
  const right=new THREE.Vector3(Math.cos(y),0,-Math.sin(y));
  targetTo.addScaledVector(right,-distTo*.13);
  targetTo.y-=distTo*.07;
 }
 flight=true;
 if(f.evening)evening(true);
 if(ring){const lp=p.clone();spa.worldToLocal(lp);ring.position.set(lp.x,lp.y-.03,lp.z);ring.material.opacity=0;}
 request();
}
function overview(){
 focus=-1;hero.dataset.state='overview';card.hidden=true;flight=true;
 if(!studio||!spa){placeSpots();return;}
 targetTo.set(0,spa.userData.H*.52,0);pitchTo=.44;
 distTo=(mobile?1.12:1)*5.35*(spa.userData.W/2.24);
 if(ring)ring.material.opacity=0;
 request();
}
q('.lx-hero__feature-close').addEventListener('click',overview);



const state={evening:false};
const eveBtn=q('[data-hero-evening]');
function evening(on){state.evening=on;eveBtn&&eveBtn.setAttribute('aria-pressed',String(on));setEvening(spa,on);hero.classList.toggle('is-evening',on);request();}
eveBtn&&eveBtn.addEventListener('click',()=>evening(!state.evening));
if(!studio&&eveBtn)eveBtn.hidden=true;

document.addEventListener('click',e=>{
 const a=e.target.closest('[data-hero-show]');if(!a||!studio)return;
 e.preventDefault();
 hero.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
 evening(true);
});
addEventListener('keydown',e=>{if(e.key==='Escape'&&focus>=0)overview();});


const bar=q('.lx-hero__models');
bar.replaceChildren(...models.map(m=>{
 const b=document.createElement('button');b.type='button';b.role='radio';b.dataset.model=m.code;
 b.setAttribute('aria-checked',String(m===current));
 b.innerHTML='<strong>'+m.name.replace('Equinox ','')+'</strong><span>'+m.variant.replace(' · Plug & Play','')+'</span>';
 b.addEventListener('click',()=>choose(m));
 return b;}));
function choose(m){
 if(m===current&&built.has(MODEL_FILE[m.code])&&ready)return;   // already on screen
 current=m;features=featuresFor(m);
 all('[data-model]').forEach(b=>b.setAttribute('aria-checked',String(b.dataset.model===m.code)));
 q('.lx-hero__name').textContent=m.name;
 q('.lx-hero__spec').textContent=[m.variant,m.seatsLabel,m.jets+' jets',m.lounger?'lounge':'open seating'].join(' · ');
 q('.lx-hero__blurb').textContent=m.defining;
 
 const priced=window.PB_PRICING?.hotTubs?.[m.code];
 const priceEl=q('[data-hero-price]');
 if(priceEl)priceEl.textContent=priced?priced.display+' CAD':'';
 fallback.src=topAsset(m);
 fallback.alt=m.name+' '+m.variant+', official top view';
 
 if(!built.has(MODEL_FILE[m.code])&&poster){
  poster.src=assetURL(ASSETS+'lx-still-'+MODEL_FILE[m.code]+'-overview.webp');
  poster.alt=m.name+' '+m.variant;
  hero.classList.remove('is-ready');reveal=false;
  hero.classList.add('is-swapping');setTimeout(()=>hero.classList.remove('is-swapping'),640);
 }
 hero.dataset.settled='false';hero.classList.add('is-loading');askedAt=performance.now();buildFor(m);
}



const loop=hero.querySelector('.lx-hero__loop');
let playing=!(reduce||saveData),heroDrawn=false;

function filmIfAble(){
 const first=performance.getEntriesByName?.('pb-first-frame')[0];
 if(first&&first.startTime>3000)return;                 // slow device: plate only
 heroDrawn=true;syncMotion();
}

function syncMotion(){
 if(!loop||!heroDrawn)return;
 if(playing){
  if(!loop.src)loop.src=mobile&&loop.dataset.mobile?loop.dataset.mobile:loop.dataset.src;
  const p=loop.play();if(p)p.catch(()=>{playing=false;});
 }else loop.pause();
}
loop&&loop.addEventListener('playing',()=>loop.classList.add('is-live'));


if(studio){
 canvas.addEventListener('pointerdown',e=>{drag=true;lastX=e.clientX;canvas.setPointerCapture(e.pointerId);hero.classList.add('is-turned');});
 canvas.addEventListener('pointermove',e=>{if(!drag)return;yawTo+=(e.clientX-lastX)*.008;lastX=e.clientX;request();});
 const stop=()=>{drag=false;};canvas.addEventListener('pointerup',stop);canvas.addEventListener('pointercancel',stop);
 canvas.addEventListener('keydown',e=>{
  if(e.key==='ArrowLeft'||e.key==='ArrowRight'){yawTo+=e.key==='ArrowLeft'?-.25:.25;request();}
  if(e.key==='Enter'&&features.length)focusOn((focus+1)%features.length);});
}

let raf=0,visible=true;
function request(){if(!raf&&visible&&studio)raf=requestAnimationFrame(frame);}
function frame(){
 raf=0;
 const now=performance.now();
 
 if(!drag&&now-lastScroll<260){lastT=now;request();return;}
 const dt=Math.min(.12,(now-(lastT||now))/1000);lastT=now;
 // A flight to a feature is slow and even; a drag answers the hand at once.
 const k=flight&&!drag?.62:1;
 yaw=lerp(yaw,yawTo,ease(.09*k,dt));pitch=lerp(pitch,pitchTo,ease(.06*k,dt));dist=lerp(dist,distTo,ease(.055*k,dt));
 target.lerp(targetTo,ease(.06*k,dt));
 // Snap once the move is visually finished, so the spa comes to a true stop
 // rather than creeping by a fraction of a pixel forever. The last fraction is
 // settled on time, not on distance: eased movement approaches its target
 // asymptotically, so on a slow device the remainder can stay just above any
 // fixed threshold for seconds, and the spa never quite arrives.
 const near=Math.abs(yaw-yawTo)<.02&&Math.abs(pitch-pitchTo)<.02&&Math.abs(dist-distTo)<.05&&target.distanceTo(targetTo)<.05;
 quiet=near&&!drag?quiet+dt:0;
 if(Math.abs(yaw-yawTo)<.0012||quiet>.6)yaw=yawTo;
 if(Math.abs(pitch-pitchTo)<.0012||quiet>.6)pitch=pitchTo;
 if(Math.abs(dist-distTo)<.004||quiet>.6)dist=distTo;
 if(target.distanceTo(targetTo)<.004||quiet>.6)target.copy(targetTo);
 const cam=studio.camera;
 cam.position.set(target.x+Math.sin(yaw)*Math.cos(pitch)*dist,target.y+Math.sin(pitch)*dist,target.z+Math.cos(yaw)*Math.cos(pitch)*dist);
 cam.lookAt(target);
 // the marker itself says what is selected; a ring over a close-up only hides the part
 const alive=tickSpa(spa,now/1000,dt);
 developing(moving0());
 studio.renderer.render(studio.scene,cam);
 
 if(reveal){reveal=false;hero.classList.add('is-ready');try{performance.mark('pb-first-frame');}catch(e){}
  warmWhenWanted();}
 placeSpots();
 const moving=yaw!==yawTo||pitch!==pitchTo||dist!==distTo||!target.equals(targetTo);
 if(!moving)flight=false;
 // Published so anything watching (and the QA suite) can tell the camera has stopped.
 hero.dataset.settled=String(!moving&&!drag);
 if(moving||drag||(!reduce&&alive))request();
}
function size(){
 if(!studio)return;
 const r=canvas.getBoundingClientRect();if(!r.width)return;
 studio.renderer.setSize(r.width,r.height,false);
 studio.camera.aspect=r.width/r.height;studio.camera.fov=r.width<r.height?40:30;studio.camera.updateProjectionMatrix();
 request();
}
if(studio)new ResizeObserver(size).observe(canvas);
new IntersectionObserver(([e])=>{
 visible=e.isIntersecting;
 if(visible){request();if(playing)syncMotion();}
 else{cancelAnimationFrame(raf);raf=0;loop.pause();}
}).observe(hero);
document.addEventListener('visibilitychange',()=>{if(document.hidden)loop.pause();else if(playing)syncMotion();});
addEventListener('scroll',()=>{lastScroll=performance.now();if(focus<0&&!drag)placeSpots();},{passive:true});


hero.pose=()=>studio&&spa?{model:current.code,feature:focus>=0?features[focus].key:'overview',
 cam:studio.camera.position.toArray(),target:target.toArray(),fov:studio.camera.fov,rimY:spa.userData.rimY,
 evening:state.evening}:null;


const photo=q('.lx-hero__photo');
let stills=[],shown=null;
if(studio&&photo&&!mobile)fetch(assetURL(ASSETS+'lx-stills.json')).then(r=>r.ok?r.json():[]).then(j=>{stills=j;request();}).catch(()=>{});
function moving0(){return yaw!==yawTo||pitch!==pitchTo||dist!==distTo||!target.equals(targetTo)||drag;}
function developing(moving){
 if(!photo||!stills.length||!spa)return;
 if(moving){if(shown){shown=null;hero.classList.remove('is-photo');}return;}
 const cam=studio.camera.position,file=MODEL_FILE[current.code];
 
 const stamp=(window.PB_MODEL_STAMP||{})[file];
 const s=stills.find(s=>s.model===file&&s.stamp===stamp&&!s.water&&s.evening===state.evening&&
  Math.hypot(s.cam[0]-cam.x,s.cam[1]-cam.y,s.cam[2]-cam.z)<.012&&
  Math.hypot(s.target[0]-target.x,s.target[1]-target.y,s.target[2]-target.z)<.012);
 if(!s||s===shown)return;
 shown=s;
 const src=assetURL(ASSETS+s.src);
 const show=()=>{if(shown===s)hero.classList.add('is-photo');};
 if(photo.getAttribute('src')===src&&photo.complete)show();
 else{photo.onload=show;photo.src=src;}
}
if(!studio)hero.classList.add('is-static');
choose(current);size();
}
